import { render, staticRenderFns } from "./NewsTabDraggable.vue?vue&type=template&id=590e4a27&"
import script from "./NewsTabDraggable.vue?vue&type=script&lang=js&"
export * from "./NewsTabDraggable.vue?vue&type=script&lang=js&"
import style0 from "./NewsTabDraggable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports